module.exports = __webpack_public_path__ + "static/media/winfile_1.137a2cdb.ico";